<router-outlet></router-outlet>
<!-- Notification placeholder -->
<et-notifications-list></et-notifications-list>
